<script>
  import options from './MobileMenuDrawer.options'
  export default options
</script>

<template>
  <article class="nlx-mobile-menu-drawer__content" v-if="drawerContent">
    <component :is="drawerContent" :mobileDrawerContext="true" />
  </article>
</template>
